import React from 'react'

const PurchaseOrderTAC = () => {
  return (
    <div
      style={{
        padding: '6rem 10% 6rem 10%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <object
        data="/mickey-purchase-order-terms-and-conditions.pdf"
        type="application/pdf"
        width="100%"
        height="1000"
      ></object>
    </div>
  )
}

export default PurchaseOrderTAC
